import { indicatorContent } from "./indicator-content";
import { pchContent } from "./pch-content";
import { valueOrgContent } from "./value-org-content";
import { contributingContent } from "./contributing-content";
import { contactCardContent } from "./contact-card-content";

export const CIIContent = {
  indicatorContent,
  pchContent,
  valueOrgContent,
  contributingContent,
  contactCardContent,
};
